import { PlusIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ContactItem } from "../components/contacts/contact-item";
import GroupsList from "../components/contacts/groups-list";
import { SubmitButton } from "../components/shared/buttons/submit-button";
import TamaguiInput from "../components/shared/tamagui-input";
import Typography from "../components/shared/typography";
import { ContactsContextWrapper } from "../hooks/ContactsContextWrapper";
import {
  GroupsContextWrapper,
  useGroupsContext,
} from "../hooks/GroupsContextWrapper";
import { useLoadContacts } from "../hooks/useLoadContacts";

export const ContactsPageChild = () => {
  const { contacts } = useLoadContacts();
  const { groups, addUser, removeUser, create, remove } = useGroupsContext();
  const navigate = useNavigate();
  const [groupName, setGroupName] = useState("");

  return (
    <div className="container mx-auto px-4 py-8">
      <Typography variant="h2" className="mb-4 text-terracotta">
        Groups
      </Typography>

      <div className="flex items-center mb-6 space-x-2 w-1/2">
        <TamaguiInput
          inputType="text"
          value={groupName}
          onChangeText={setGroupName}
          placeholder="New group name"
          fullWidth
        />
        <SubmitButton
          size="sm"
          onClick={async () => {
            if (!groupName) return;
            await create({ name: groupName });
            setGroupName("");
          }}
        >
          Create
        </SubmitButton>
      </div>

      <GroupsList groups={groups} remove={remove} />

      <Typography variant="h2" className="mb-8 text-terracotta">
        Contacts
      </Typography>

      <div className="flex justify-end mb-4">
        <SubmitButton
          size="sm"
          onClick={() => navigate("/contacts/create")}
          icon={<PlusIcon className="w-4 h-4" color="white" />}
        >
          Add Contact
        </SubmitButton>
      </div>

      <div className="grid gap-4">
        {contacts.map((contact) => (
          <ContactItem
            key={contact.id}
            contact={contact}
            groups={groups}
            onAddToGroup={(groupId) =>
              addUser({ groupId, userId: contact.related_user_id })
            }
            onRemoveFromGroup={(groupId) =>
              removeUser({ groupId, userId: contact.related_user_id })
            }
          />
        ))}
      </div>
    </div>
  );
};

export const ContactsPage = () => {
  return (
    <GroupsContextWrapper>
      <ContactsContextWrapper>
        <ContactsPageChild />
      </ContactsContextWrapper>
    </GroupsContextWrapper>
  );
};
